import { render } from "./GPSTeamDashboard.vue?vue&type=template&id=4a36a856&scoped=true"
import script from "./GPSTeamDashboard.vue?vue&type=script&lang=js"
export * from "./GPSTeamDashboard.vue?vue&type=script&lang=js"

import "./GPSTeamDashboard.vue?vue&type=style&index=0&id=4a36a856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a36a856"]])

export default __exports__